import { useTranslations } from 'next-intl'
import Image from 'next/image'

type ProductInfoPolicyProps = {
  gender: string
  collections: Array<{ value: string } | string>
}

const WINTER_COLLECTION_ID = '68fb50b2951dc3749b0b68e9'

const OUTLET_COLLECTION_ID = '63b8e548654bd10f5d7fe16c'

const isWinterCollection = (
  collections: Array<{ value: string } | string>
): boolean => {
  return collections.some((col) =>
    typeof col === 'string'
      ? col === WINTER_COLLECTION_ID
      : col.value === WINTER_COLLECTION_ID
  )
}

// với sản phẩm thuộc bộ sưu tập outlet thì không hiển thị chính sách đổi trả
const isOutletCollection = (
  collections: Array<{ value: string } | string>
): boolean => {
  return collections.some((col) =>
    typeof col === 'string'
      ? col === OUTLET_COLLECTION_ID
      : col.value === OUTLET_COLLECTION_ID
  )
}

export const ProductInfoPolicy = ({
  gender,
  collections,
}: ProductInfoPolicyProps) => {
  const t = useTranslations('product_detail')
  const infosFemale = [
    {
      icon: '/icons/product/return.svg',
      title: t.rich('policy.female.easy_return', {
        newline: () => <br />,
      }),
    },
    {
      icon: '/icons/product/return-60.svg',
      title: t.rich('policy.female.return60', {
        newline: () => <br />,
      }),
    },
    {
      icon: '/icons/product/phone.svg',
      title: t.rich('policy.female.hotline', {
        newline: () => <br />,
      }),
    },
    {
      icon: '/icons/product/location.svg',
      title: t.rich('policy.female.pickup', {
        newline: () => <br />,
      }),
    },
  ]

  const infosMale = [
    {
      icon: '/icons/product/free-ship.svg',
      title: t.rich('policy.male.freeship', {
        newline: () => <br />,
      }),
    },
    {
      icon: '/icons/product/return-60.svg',
      title: t.rich('policy.male.return60', {
        newline: () => <br />,
      }),
    },
    {
      icon: '/icons/product/phone.svg',
      title: t.rich('policy.male.hotline', {
        newline: () => <br />,
      }),
    },
    {
      icon: '/icons/product/location.svg',
      title: t.rich('policy.male.pickup', {
        newline: () => <br />,
      }),
    },
  ]

  const shouldShowFemalePolicy =
    gender !== 'MALE' || isWinterCollection(collections)
  const allInfos = shouldShowFemalePolicy ? infosFemale : infosMale

  const isOutlet = isOutletCollection(collections)
  const infos = isOutlet
    ? allInfos.filter((item) => !item.icon.includes('return'))
    : allInfos

  return (
    <div
      className='text-center lg:!mt-2 lg:border-t lg:border-t-neutral-200 lg:pb-0 lg:pt-2'
      id='product-detail-policy'
    >
      <ul className='grid grid-cols-2 gap-2 rounded-lg bg-neutral-100 p-2 lg:gap-8 lg:gap-y-4 lg:p-4'>
        {infos.map((item, index) => (
          <li key={index} className='flex items-center gap-2 lg:gap-3'>
            <Image
              src={item.icon}
              alt={item.title as string}
              width={28}
              height={28}
              className='rounded-lg lg:h-10.5 lg:w-10.5'
            />
            <p className='text-left text-xxs leading-3 text-neutral-900 lg:text-xs'>
              {item.title}
            </p>
          </li>
        ))}
      </ul>
    </div>
  )
}
